/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-plusplus */
import Accordion from '@common/Accordion';
import Backdrop from '@common/Backdrop';
import Typography from '@common_typography';

import { useApolloClient } from '@apollo/client';
import {
    modules, custDataNameCookie, features, customerTokenKey,
} from '@config';
import { getLoginInfo, removeIsLoginFlagging, removeHavePhoneFlagging } from '@helper_auth';
import { priceVar, storeConfigVar } from '@core/services/graphql/cache';
import { removeCookies } from '@helper_cookies';
import { removeCartId } from '@helper_cartid';
import { localCompare, localTotalCart } from '@services/graphql/schema/local';

import cx from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Cookies from 'js-cookie';
import firebase from 'firebase';

const Layout = (props) => {
    const {
        children, t, title, activeMenu, storeConfig,
    } = props;
    const pushIf = (condition, ...elements) => (condition ? elements : []);
    const router = useRouter();
    let titlePage = '';

    const isLogin = getLoginInfo();

    const pwaConfig = storeConfigVar();

    const client = useApolloClient();

    const firebaseEnv = storeConfig?.firebase_setting_sociallogin_is_production === '1' ? 'prod' : 'dev';

    // handle logout action
    const handleLogout = async () => {
        window.backdropLoader(true);
        if (!firebase.apps.length) {
            firebase.initializeApp(features.firebase.config[firebaseEnv]);
        } else {
            firebase.app(); // if already initialized, use that one
        }
        if (features.firebase.config[firebaseEnv].apiKey) {
            firebase
                .auth()
                .signOut()
                .then(() => {
                    // Sign-out successful.
                })
                .catch(() => {
                    // An error happened.
                });
        }
        try {
            const token = localStorage.getItem(customerTokenKey);
            const logoutSession = await fetch('/api/remove-token', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token) && { Authorization: `Bearer ${token}` },
                },
            });
            const res = await logoutSession.json();
            if (res?.data?.revokeCustomerToken?.result) {
                localStorage.removeItem(customerTokenKey);
                Cookies.remove(custDataNameCookie);
                Cookies.remove(customerTokenKey);
                Cookies.remove('admin_id');
                removeIsLoginFlagging();
                removeHavePhoneFlagging();
                priceVar({});
                removeCartId();
                removeCookies('uid_product_compare');
                client.writeQuery({ query: localTotalCart, data: { totalCart: 0 } });
                client.writeQuery({ query: localCompare, data: { item_count: 0 } });
                window.backdropLoader(false);
                router.push('/customer/account/login');
            } else {
                localStorage.removeItem(customerTokenKey);
                Cookies.remove(customerTokenKey);
                window.backdropLoader(false);
                router.push('/customer/account/login');
            }
        } catch {
            localStorage.removeItem(customerTokenKey);
            Cookies.remove(customerTokenKey);
            window.backdropLoader(false);
            router.push('/customer/account/login');
        }
    };

    const menu = [
        { href: '/customer/account', title: t('customer:menu:accountSummary') },
        { title: t('customer:menu:accountSummary') },
        ...pushIf(modules.notification.enabled, {
            href: '/inboxnotification/notification',
            title: t('customer:menu:notification'),
        }),
        { href: '/sales/order/history', title: t('customer:menu:orderHistory') },
        ...pushIf(modules.wishlist.enabled, {
            href: '/wishlist',
            title: t('customer:wishlist:title'),
        }),
        { href: '/customer/account/address', title: t('customer:menu:address') },
        ...pushIf(modules.productreview.enabled, {
            href: '/review/customer',
            title: t('customer:menu:myProductReview'),
        }),
        { href: '/customer/account/profile', title: t('customer:menu:accountInformation') },
        { href: '/customer/newsletter', title: t('customer:menu:newsletter') },
        ...pushIf(modules.customer.menu.download, { href: '/sales/downloadable/history', title: t('customer:menu:myDownload') }),
        ...pushIf(modules.customer.menu.return, {
            href: storeConfig?.OmsRma?.enable_oms_rma ? storeConfig.OmsRma.oms_rma_link : '/rma/customer',
            title: t('customer:menu:return'),
        }),
        ...pushIf(modules.storecredit.enabled, {
            href: '/customer/account/storecredit',
            title: t('customer:menu:storeCredit'),
        }),
        ...pushIf(modules.giftcard.enabled, {
            href: '/awgiftcard/card',
            title: 'Gift Card',
        }),
        // ...pushIf(modules.rewardpoint.enabled, {
        //     href: '/aw_rewardpoints/info',
        //     title: t('customer:menu:rewardPoint'),
        // }),
        ...pushIf(pwaConfig?.amrewards_general_enabled, {
            href: '/amrewards',
            title: t('customer:menu:rewardPoint'),
        }),
        {
            title: t('customer:button:logout'),
        },
    ];
    for (let index = 0; index < menu.length; index++) {
        const item = menu[index];
        if (item.href === router.asPath) {
            titlePage = item.title;
        }
    }

    if (!isLogin) {
        return <Backdrop open />;
    }

    return (
        <>
            <div className="desktop:flex desktop:flex-row desktop:gap-x-[18px] mobile:grid mobile:grid-cols-1">
                <div className={cx('desktop:hidden', 'mb-6')}>
                    <Accordion
                        label="Menu"
                        classLabel={cx('p-2', '!font-normal', '!text-base', '!text-neutral-500', '!uppercase')}
                        classSummary={cx('p-3', 'border-[1px]', 'border-neutral-100', 'rounded-lg', 'shadow-sm')}
                    >
                        <div className={cx('w-full', 'border-[2px]', 'border-neutral-100', 'rounded-lg')}>
                            <ul>
                                {menu.map((val, idx) => {
                                    if (idx === 0) {
                                        return null;
                                    }
                                    if (idx === 1) {
                                        return (
                                            <li
                                                key={idx}
                                                className={cx(
                                                    'mb-4', 'py-4', 'text-sm', 'text-neutral-400', 'uppercase', 'tracking-[1.8px]',
                                                    'flex', 'items-center', 'font-normal', 'rounded-tl-md', 'rounded-tr-md', 'hover:bg-neutral-50', {
                                                        // eslint-disable-next-line max-len
                                                        'bg-neutral-50before:content-[" "] before:absolute before:bg-yellow-300 before:h-[25px] before:w-[5px] !font-bold text-neutral-black':
                                                        router.asPath === '/customer/account' || activeMenu === '/customer/account',
                                                    },
                                                )}
                                            >
                                                <Link href="/customer/account">
                                                    <span className="pl-[25px]">{val.title}</span>
                                                </Link>
                                            </li>
                                        );
                                    }
                                    if (val.title === t('customer:menu:return')) {
                                        return (
                                            <>
                                                <li
                                                    key={idx}
                                                    className={cx(
                                                        'mb-4', 'py-4', 'text-sm', 'text-neutral-400', 'uppercase',
                                                        'tracking-[1.8px]', 'flex', 'items-center', 'font-normal', 'hover:bg-neutral-50', {
                                                            // eslint-disable-next-line max-len
                                                            'bg-neutral-50 before:content-[" "] before:absolute before:bg-yellow-300 before:h-[25px] before:w-[5px] !font-bold text-neutral-black':
                                                            router.asPath === val.href || activeMenu === val.href,
                                                        },
                                                    )}
                                                >
                                                    <Link href={val.href}>
                                                        <span className="pl-[25px]">{val.title}</span>
                                                    </Link>
                                                </li>
                                            </>
                                        );
                                    }
                                    if (modules.productreview.enabled && val.title === t('customer:menu:myProductReview')) {
                                        return (
                                            <>
                                                <li
                                                    key={idx}
                                                    className={cx(
                                                        'mb-4', 'py-4', 'text-sm', 'text-neutral-400', 'uppercase', 'tracking-[1.8px]',
                                                        'flex', 'items-center', 'font-normal', 'hover:bg-neutral-50', {
                                                            // eslint-disable-next-line max-len
                                                            'bg-neutral-50 before:content-[" "] before:absolute before:bg-yellow-300 before:h-[25px] before:w-[5px] !font-bold text-neutral-black':
                                                            router.asPath === val.href || activeMenu === val.href,
                                                        },
                                                    )}
                                                >
                                                    <Link href={val.href}>
                                                        <span className="pl-[25px]">{val.title}</span>
                                                    </Link>
                                                </li>
                                            </>
                                        );
                                    }
                                    if (val.title === t('customer:button:logout')) {
                                        return (
                                            <>
                                                <li
                                                    onClick={handleLogout}
                                                    key={idx}
                                                    className={cx(
                                                        'py-4', 'text-sm', 'text-neutral-400', 'uppercase', 'tracking-[1.8px]',
                                                        'flex', 'items-center', 'font-normal', 'rounded-bl-md', 'rounded-br-md',
                                                        'hover:bg-neutral-50', 'hover:cursor-pointer',
                                                    )}
                                                >
                                                    <span className="pl-[25px]">{val.title}</span>
                                                </li>
                                            </>
                                        );
                                    }
                                    return (
                                        <li
                                            key={idx}
                                            className={cx(
                                                'mb-4', 'py-4', 'text-sm', 'text-neutral-400', 'uppercase', 'tracking-[1.8px]', 'flex',
                                                'items-center', 'font-normal', 'hover:bg-neutral-50', {
                                                    // eslint-disable-next-line max-len
                                                    'bg-neutral-50 before:content-[" "] before:absolute before:bg-yellow-300 before:h-[25px] before:w-[5px] !font-bold text-neutral-black':
                                                    router.asPath === val.href || activeMenu === val.href,
                                                },
                                            )}
                                        >
                                            <Link href={val.href}>
                                                <span className="pl-[25px]">{val.title}</span>
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </Accordion>
                </div>
                <div className={cx('desktop:basis-3/12', 'xs:basis-full', 'mobile:max-desktop:hidden')}>
                    <div className={cx('rounded-lg', 'shadow-sm')}>
                        <ul>
                            {menu.map((val, idx) => {
                                if (idx === 0) {
                                    return (
                                        <li
                                            key={idx}
                                            className={cx(
                                                'mx-3',
                                                'pt-3',
                                                'pb-5',
                                                'text-[18px]',
                                                'font-semibold',
                                                'leading-7',
                                                'border-b-[1px]',
                                                'border-neutral-200',
                                                'hidden',
                                            )}
                                        >
                                            {val.title}
                                        </li>
                                    );
                                }
                                if (idx === 1) {
                                    return (
                                        <li
                                            key={idx}
                                            className={cx(
                                                'mb-4', 'py-2.5', 'text-[12px]', 'text-neutral-400', 'uppercase', 'tracking-[2.4px]', 'flex',
                                                'items-center', 'font-normal', 'hover:bg-neutral-50', {
                                                // eslint-disable-next-line max-len
                                                    'bg-neutral-50 border-y-[5px] border-neutral-50 before:content-[" "] before:absolute before:bg-yellow-300 before:h-[25px] before:w-[5px] !font-bold text-neutral-black':
                                                    router.asPath === '/customer/account' || activeMenu === '/customer/account',
                                                },
                                            )}
                                        >
                                            <Link href="/customer/account">
                                                <span className="pl-[25px]">{val.title}</span>
                                            </Link>
                                        </li>
                                    );
                                }
                                if (val.title === t('customer:menu:return')) {
                                    return (
                                        <>
                                            <li
                                                key={idx}
                                                // eslint-disable-next-line max-len
                                                className={cx('mb-4', 'py-2.5', 'text-[12px]', 'text-neutral-400', 'uppercase', 'tracking-[2.4px]', 'flex', 'items-center', 'font-normal', 'hover:bg-neutral-50', {
                                                    // eslint-disable-next-line max-len
                                                    'bg-neutral-50 border-y-[5px] border-neutral-50 before:content-[" "] before:absolute before:bg-yellow-300 before:h-[25px] before:w-[5px] !font-bold text-neutral-black':
                                                        router.asPath === val.href || activeMenu === val.href,
                                                })}
                                            >
                                                <Link href={val.href}>
                                                    <span className="pl-[25px]">{val.title}</span>
                                                </Link>
                                            </li>
                                        </>
                                    );
                                }
                                if (modules.productreview.enabled && val.title === t('customer:menu:myProductReview')) {
                                    return (
                                        <>
                                            <li
                                                key={idx}
                                                // eslint-disable-next-line max-len
                                                className={cx('mb-4', 'py-2.5', 'text-[12px]', 'text-neutral-400', 'uppercase', 'tracking-[2.4px]', 'flex', 'items-center', 'font-normal', 'hover:bg-neutral-50', {
                                                    // eslint-disable-next-line max-len
                                                    'bg-neutral-50 border-y-[5px] border-neutral-50 before:content-[" "] before:absolute before:bg-yellow-300 before:h-[25px] before:w-[5px] !font-bold text-neutral-black':
                                                        router.asPath === val.href || activeMenu === val.href,
                                                })}
                                            >
                                                <Link href={val.href}>
                                                    <span className="pl-[25px]">{val.title}</span>
                                                </Link>
                                            </li>
                                        </>
                                    );
                                }
                                if (val.title === t('customer:button:logout')) {
                                    return (
                                        <>
                                            <li
                                                onClick={handleLogout}
                                                key={idx}
                                                className={cx(
                                                    'mb-4', 'py-2.5', 'text-[12px]', 'text-neutral-400', 'uppercase', 'tracking-[2.4px]',
                                                    'flex', 'items-center', 'font-normal', 'hover:bg-neutral-50', 'hover:cursor-pointer',
                                                )}
                                            >
                                                <span className="pl-[25px]">{val.title}</span>
                                            </li>
                                        </>
                                    );
                                }
                                return (
                                    <li
                                        key={idx}
                                        className={cx(
                                            'mb-4', 'py-2.5', 'text-[12px]', 'text-neutral-400', 'uppercase', 'tracking-[2.4px]',
                                            'flex', 'items-center', 'font-normal', 'hover:bg-neutral-50', {
                                                // eslint-disable-next-line max-len
                                                'bg-neutral-50 border-y-[5px] border-neutral-50 before:content-[" "] before:absolute before:bg-yellow-300 before:h-[25px] before:w-[5px] !font-bold text-neutral-black':
                                                router.asPath === val.href || activeMenu === val.href,
                                            },
                                        )}
                                    >
                                        <Link href={val.href}>
                                            <span className="pl-[25px]">{val.title}</span>
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
                <div className="desktop:basis-9/12 xs:basis-full sm:basis-full">
                    <Typography
                        variant="h2"
                        letter="capitalize"
                        color="text-neutral-black"
                        className={cx('mobile:!text-[1.6rem]', 'pl-0', 'mb-[30px]', 'capitalize', '!text-[2.4rem]')}
                    >
                        {title || titlePage}
                    </Typography>
                    {children}
                </div>
            </div>
        </>
    );
};

export default Layout;
